import { Box, Button, Text } from '@chakra-ui/react';
import React from 'react';
import { Close } from '../../Icons/Close';
import { CommonProps } from '../../interfaces/components';
import { useTranslation } from 'react-i18next';
import AppBenefit from '../../components/fidenza/Benefit';
import { disptchCTAClickObject } from '../../Analytics';

const DownloadApp = ({ active, setActive }: CommonProps) => {
  const { t } = useTranslation();

  const onAndroid = () => {
    const url = 'https://play.google.com/store/apps/details?id=com.valueretail.fv&pli=1';
    disptchCTAClickObject('fidenza', 'Button', 'Download App', 'Google Play', url);
    window.open(url, '_blank');
  };

  const oniOS = () => {
    const url = 'https://apps.apple.com/us/app/fidenza-village/id1317279652';
    disptchCTAClickObject('fidenza', 'Button', 'Download App', 'Apple Store', url);
    window.open(url, '_blank');
  };

  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.2)"
        transition="all 1s"
        zIndex={4}
        onClick={() => setActive()}
      />
      <Box
        zIndex={8}
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        backgroundColor="rgba(255, 255, 255, 1);"
        padding="15px 15px 30px 15px"
        width={['100%', '100%', '600px', '700px']}
        height={['100%', '100%', 'max-content']}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        overflowY={['auto', 'auto', 'hidden']}
        pb={['10', '10', '6']}
      >
        <Close
          boxSize={[6, 6, 7]}
          position="absolute"
          top={['30px', '30px', '30px']}
          right={['30px', '30px', '30px']}
          cursor="pointer"
          onClick={() => setActive()}
          zIndex={30}
        />
        <Text
          mt="10"
          textAlign="center"
          fontWeight="300"
          fontFamily="SangBleuBPLight"
          className="copy"
          fontSize={['14px', '14px', '18px', '20px', '20px']}
          lineHeight={['20px', '20px', '24px', '26px', '26px']}
        >
          {t('fv_download_app_title')}
        </Text>

        <Text
          as="i"
          textAlign="center"
          fontWeight="400"
          fontFamily="JosefinSans"
          fontSize={['12px', '12px', '12px', '15px', '15px']}
          lineHeight={['16px', '16px', '16px', '18px', '18px']}
          className="gold"
          maxW="80%"
          mt="5"
        >
          {t('fv_download_app_subtitle')}
        </Text>

        <Box
          display="flex"
          flexFlow={['column', 'column', 'row']}
          flexWrap={['nowrap', 'nowrap', 'wrap']}
          maxW="500px"
          justifyContent="center"
          alignItems="center"
          mt={['5', '5', '8']}
          gap="5"
        >
          <AppBenefit text={t('fv_download_app_feature_one')} />
          <AppBenefit text={t('fv_download_app_feature_two')} />
          <AppBenefit text={t('fv_download_app_feature_three')} hidden />
          <AppBenefit text={t('fv_download_app_feature_four')} />
          <AppBenefit text={t('fv_download_app_feature_five')} hidden />
        </Box>

        <Text
          mt={['5', '5', '8']}
          textAlign="center"
          fontWeight="400"
          fontFamily="JosefinSans"
          className="copy"
          fontSize={['12px', '12px', '14px', '16px', '16px']}
          lineHeight={['16px', '16px', '18px', '20px', '20px']}
          maxW="80%"
        >
          {t('fv_download_app_description')}
        </Text>

        <Box
          display="flex"
          // flexDir="column"
          justifyContent="center"
          alignItems="center"
          gap="3"
          mt="8"
          mb={['5', '5', '0', '5']}
        >
          <Button
            bg="white"
            border="1px solid gray"
            borderRadius="0px"
            px="25px"
            h="46px"
            color="#455255"
            _hover={{ bg: '#C29F6B', color: 'white', border: '1px solid #C29F6B' }}
            pt={['0', '0', '1']}
            onClick={oniOS}
          >
            <Text
              textAlign="center"
              fontWeight="400"
              fontFamily="JosefinSans"
              textTransform="uppercase"
              fontSize={['12px', '12px', '14px', '14px', '14px']}
            >
              {t('fv_download_app_ios')}
            </Text>
          </Button>

          <Button
            bg="white"
            border="1px solid gray"
            borderRadius="0px"
            px="25px"
            h="46px"
            color="#455255"
            _hover={{ bg: '#C29F6B', color: 'white', border: '1px solid #C29F6B' }}
            pt={['0', '0', '1']}
            onClick={onAndroid}
          >
            <Text
              textAlign="center"
              fontWeight="400"
              fontFamily="JosefinSans"
              textTransform="uppercase"
              fontSize={['12px', '12px', '14px', '14px', '14px']}
            >
              {t('fv_download_app_android')}
            </Text>
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default DownloadApp;
